import * as yup from "yup";
const nameRegExp = /^[A-Za-z]+$/; // Regular expression to allow only letters
const phoneRegExp = /^(01[0,1,2,5])\d{8}$/;
const nameSpaceRegExp = /^[a-zA-Z ]+$/; // Regular expression to allow only letters and spaces

const arabicEnglishRegExp = /^[a-zA-Z\u0600-\u06FF ]*$/;
const arabicEnglishNumbersRegExp = /^[a-zA-Z\u0600-\u06FF0-9 ]*$/;
export const EnSchema = yup.object().shape({
  person_name: yup
    .string()
    .min(3, "At least 3 characters long")
    .trim()
    .matches(arabicEnglishRegExp, "Name is invalid")
    .required("Required"),
  phoneNumber: yup
    .string()
    .matches(
      phoneRegExp,
      "Phone number must start with (010/011/012/015) and at least 11 digits"
    )
    .required("Required"),
  email: yup.string().email("Please enter a valid email").required("Required"),
  business_name: yup
    .string()
    .min(3, "At least 3 characters long")
    .trim()
    .matches(arabicEnglishNumbersRegExp, "Name is invalid")
    .required("Required"),
  governorate: yup
    .string()
    .min(3, "At least 3 characters long")
    .required("Required"),
});
export const initialValues = {
  person_name: "",
  phoneNumber: "",
  email: "",
  business_name: "",
  governorate: "",
};
